var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4987 2.66732C10.3311 2.66732 11.9486 3.59149 12.9091 5.00065H11.1654V6.33398H15.1654V2.33398H13.832V4.00022C12.6162 2.38176 10.6803 1.33398 8.4987 1.33398C4.8168 1.33398 1.83203 4.31875 1.83203 8.00065H3.16536C3.16536 5.05513 5.55318 2.66732 8.4987 2.66732ZM13.832 8.00065C13.832 10.9462 11.4442 13.334 8.4987 13.334C6.66632 13.334 5.04875 12.4098 4.08832 11.0007H5.83203V9.66732H1.83203V13.6673H3.16536V12.0011C4.38124 13.6195 6.31712 14.6673 8.4987 14.6673C12.1806 14.6673 15.1654 11.6825 15.1654 8.00065H13.832Z",
    fill: "#96999C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoop);
export default __webpack_public_path__ + "static/media/loop.4180f4df5fbe7991b67239776514a223.svg";
export { ForwardRef as ReactComponent };